import { Badge } from '@/components/ui/badge'
import { cn } from '@/lib/utils'
import { parseQuantity, parseOptionalQuantity } from '@/lib/quantity-utils'

export const getStockStatus = (
  quantity: number | string,
  reorderLevel: number | string | null
): 'Out of Stock' | 'Low Stock' | 'In Stock' => {
  const qty = parseQuantity(quantity)
  const reorder = parseOptionalQuantity(reorderLevel)

  if (qty === 0) return 'Out of Stock'
  if (reorder != null && reorder > 0 && qty <= reorder) return 'Low Stock'
  return 'In Stock'
}

export const getStockStatusBadge = (
  quantity: number | string,
  reorderLevel: number | string | null,
  className?: string
) => {
  const qty = parseQuantity(quantity)
  const reorder = parseOptionalQuantity(reorderLevel)

  if (qty === 0) {
    return (
      <Badge variant="outline" className={cn('text-xs bg-destructive/12 text-destructive border-destructive/20', className)}>
        Out of Stock
      </Badge>
    )
  }

  if (reorder != null && reorder > 0 && qty <= reorder) {
    return (
      <Badge variant="outline" className={cn('text-xs bg-warning/15 text-warning border-warning/20', className)}>
        Low Stock
      </Badge>
    )
  }

  return (
    <Badge variant="outline" className={cn('text-xs bg-success/12 text-success border-success/20', className)}>
      In Stock
    </Badge>
  )
}
